import router from '@/router'
import { Firebase } from '@/firebase/init'
import { buildSuccess, handleError } from '@/utils/utils'

export default {
  /**
   * Callback fired when user login
   */
  login: async ({ commit, dispatch }) => {
    console.log('LOGIN')

    const userFB = Firebase.auth().currentUser

    if (userFB != null) {
      const { emailVerified } = userFB
      console.log(emailVerified)

      if (emailVerified) {
        commit('setUserConfirmedMail', true)
      } else {
        commit('setUserConfirmedMail', false)
      }

      // Set store for logged user
      // Listen for changes on User info
      dispatch('currentUser/openDBChannel', null, { root: true })
      dispatch('classrooms/openDBChannel', null, { root: true })
      commit('setUser', true)
    }
  },

  /**
   * Callback fired when user logout
   */
  logout: ({ commit, dispatch }) => {
    commit('setUser', null)
    commit('setUserConfirmedMail', null)
    dispatch(
      'currentUser/closeDBChannel',
      { clearModule: true },
      { root: true }
    )
    dispatch('classrooms/closeDBChannel', { clearModule: true }, { root: true })
    dispatch('dates/closeDBChannel', { clearModule: true }, { root: true })
    const currentRouter = router.app.$route
    if (!(currentRouter.meta && currentRouter.meta.authNotRequired)) {
      router.push('/login')
    }
  },

  /**
   * Callback fired when user sign up
   */
  signUp: ({ commit, dispatch, rootState }, user) => {
    return new Promise((resolve, reject) => {
      Firebase.auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(async userFB => {
          // Signed in
          dispatch(
            'currentUser/patch',
            {
              displayName: user.name,
              email: user.email
            },
            { root: true }
          )
          console.log(rootState.currentUser)
          commit('setUser', true)

          userFB.user
            .sendEmailVerification()
            .then(function() {
              // Email sent.
              console.log('Email sent')
            })
            .catch(function(error) {
              // An error happened.
              console.log(error)
            })

          buildSuccess(null, commit, resolve, router.push({ name: 'home' }))
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  /**
   * Do login
   */
  doLogin: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      Firebase.auth()
        .signInWithEmailAndPassword(user.email, user.password)
        .then(() => {
          // Signed in
          buildSuccess(null, commit, resolve, router.push({ name: 'home' }))
        })
        .catch(error => {
          if (error.code === 'auth/wrong-password') {
            error.message = 'Usuario/Constraseña inválida'
          } else {
            error.message = ''
          }
          console.log(error)
          handleError(error, commit, reject)
        })
    })
  },

  /**
   * Recover password
   */
  sendRecoverPasswordEmail: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      Firebase.auth()
        .sendPasswordResetEmail(user.email)
        .then(() => {
          // Signed in
          buildSuccess(null, commit, resolve, router.push({ name: 'home' }))
        })
        .catch(error => {
          if (error.code === 'auth/wrong-password') {
            error.message = 'Usuario/Constraseña inválida'
          } else {
            error.message = ''
          }
          console.log(error)
          handleError(error, commit, reject)
        })
    })
  },

  /**
   * Delete account
   */
  deleteAccount: ({ commit }) => {
    return new Promise((resolve, reject) => {
      // Delete account
      console.log(`Delete account`)

      const auth = Firebase.auth()
      const user = auth.currentUser

      user.delete()
        .then(() => {
          // User deleted.
          buildSuccess(null, commit, resolve, router.push({ name: 'home' }))
        })
        .catch(error => {
          // An error ocurred
          // ...
          if (error.code === 'auth/wrong-password') {
            error.message = 'Usuario/Constraseña inválida'
          } else {
            error.message = ''
          }
          console.log(error)
          handleError(error, commit, reject)
        })
    })
  }
}
